import { render, staticRenderFns } from "./all-config-reason.vue?vue&type=template&id=1ab6ff61"
import script from "./all-config-reason.vue?vue&type=script&lang=ts"
export * from "./all-config-reason.vue?vue&type=script&lang=ts"
import style0 from "./all-config-reason.vue?vue&type=style&index=0&id=1ab6ff61&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports